import _ from 'lodash'
import Backbone from 'backbone'
import IdSelectFilter from './id-select-filter'
import template from './tag-filter.hbs'
import SetOperatorSelect from './set-operator-select'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import TagsChooser from 'scoreboard/components/tags-chooser'

var TagFormView = FormView.extend({

	test: function() {
		return FormView.prototype.test.apply(this, arguments) ||
			this.$('.id-select').val().length == 0 ? i18n.get('common.error.mustSelectTag') : null
	}

})


var TagFilter = IdSelectFilter.extend({

	className: 'report-filters tag-filter',

	initialize: function(options) {
		IdSelectFilter.prototype.initialize.apply(this, arguments)
		let selectOptions = _.extend({}, options, {
			label: i18n.get('datasets.filters.type')
		})
		this.setOperator = new SetOperatorSelect(selectOptions)
		this.formViewType = TagFormView
	},

	render: function () {
		this.$el.html(template())
		this.$el.prepend(this.setOperator.el)
		this.setOperator.render()

		this.tagsChooser = new TagsChooser({
			globalTags: this.selectionData,
			tags: _.values(this.data.metadata).map(tag => tag.label),
			selectOptions: {
				creatable: false
			},
			el: this.$('.id-select')
		}).render()

		return this
	},

	gather: function(e) {
		this.data.values = []
		_.forEach(this.$('.id-select').val(), selectedLabel => {
			let id = _.find(this.selectionData, option => {
				return option.label === selectedLabel
			})?.id

			if (id) {
				this.data.values.push(id)
				this.data.metadata[id] = this.selectionMap[id]
			}
		})
		this.data.operator = this.setOperator.gather().operator
		return this.data
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.setOperator, this.tagsChooser],
			'remove')
	}

})

export default TagFilter

TagFilter.__filename__ = 'reports/wizard/filter-meta/tag-filter.js'
